// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_SIA","cls2":"TransactionalPricingModal-cls2_rXO TransactionalPricingModal-cls1_SIA"};